import type { ProductLabel } from '../../../../../product/index';
import {
  ProductLabelList,
  ProductLabelMark,
  type ProductLabelVariant,
} from '@vs-shop/commerce-ui/productLabel';
import { getLucideIconFromKebabString } from '../../../../../shared/utils/lucideIcons';

type Props = {
  variant: ProductLabelVariant;
  labels: readonly ProductLabel[];
};

/**
 * rcprofi's label set, rendered as the shared chips.
 *
 * What is this tenant's and stays here: how a label's kebab-cased icon name
 * resolves to an icon component. The caller picks and orders the labels —
 * see `cardLabels` and `galleryLabels`.
 */
export function ProductLabels({ variant, labels }: Props) {
  return (
    <ProductLabelList>
      {labels.map((label) => {
        const icon = label.icon ?? null;
        const IconComponent = icon ? getLucideIconFromKebabString(icon) : null;

        return (
          <ProductLabelMark
            key={label.code}
            variant={variant}
            style={{
              color: label.textColor,
              backgroundColor: label.color,
            }}
          >
            {IconComponent ? <IconComponent className="size-4 shrink-0" /> : null}
            {label.name}
          </ProductLabelMark>
        );
      })}
    </ProductLabelList>
  );
}
